<div
    [ngClass]="{
        'agpr-compactView' : compactDisplay,
        'agpr-fullView' : !compactDisplay
    }"
>
    <div class="agpr-undesirablesReport-mainContainer">
        <div class="agpr-undesirablesReport-mainRow">
            <div
                class="agpr-undesirablesReport-container"
                [ngClass]="{'agpr-undesirablesReport-container-selected' :
                    selectedType === statTypes.UNOPENED && selectedIndividualRecipient === data
                }"
                (agprClickUnless)="selectStatType(statTypes.UNOPENED)"
                [pTooltip]="openTracking ? null : ('Discover.distributionReport.tracking.openDisabled' | localize)"
                tooltipPosition="top"
                tabindex="0"
                (keydown)="statCardKeydown($event, statTypes.UNOPENED)"
            >
                <h5 class="agpr-undesirablesReport-typeLabel">
                    {{'Discover.distributionReport.recipient.statsType.unopened' | localize}}
                </h5>
                <div
                    *ngIf="!openTracking"
                    class="agpr-undesirablesReport-typeCount"
                    [ngClass]="{'agpr-undesirablesReport-typeDisabled': !openTracking}"
                >
                    {{ 'N/A' | localize }}
                </div>
                <div
                    *ngIf="openTracking"
                    class="agpr-undesirablesReport-typeCount"
                >
                    {{data.unopened | number}}
                </div>
            </div>
            <div
                class="agpr-undesirablesReport-container"
                [ngClass]="{'agpr-undesirablesReport-container-selected' :
                    selectedType === statTypes.SOFT_BOUNCED && selectedIndividualRecipient === data
                }"
                (agprClickUnless)="selectStatType(statTypes.SOFT_BOUNCED)"
                tabindex="0"
                (keydown)="statCardKeydown($event, statTypes.SOFT_BOUNCED)"
            >
                <h5 class="agpr-undesirablesReport-typeLabel">
                    {{'Discover.distributionReport.recipient.statsType.softBounced' | localize}}
                </h5>
                <div class="agpr-undesirablesReport-typeCount">{{data.softBounced | number}}</div>
            </div>
            <div
                class="agpr-undesirablesReport-container"
                [ngClass]="{'agpr-undesirablesReport-container-selected' :
                    selectedType === statTypes.BLOCKED && selectedIndividualRecipient === data
                }"
                (agprClickUnless)="selectStatType(statTypes.BLOCKED)"
                tabindex="0"
                (keydown)="statCardKeydown($event, statTypes.BLOCKED)"
            >
                <h5 class="agpr-undesirablesReport-typeLabel">
                    {{'Discover.distributionReport.recipient.statsType.blocked' | localize}}
                    <span
                        *ngIf="data.blocked > 0"
                        role="img"
                        class="agpr-undesirablesReport-infoCircle fa-regular fa-circle-info"
                        agprTooltip="Discover.distributionReport.recipient.blocked.tooltip"
                        tooltipPosition="top"
                        [escape]="false"
                    ></span>
                </h5>
                <div class="agpr-undesirablesReport-typeCount">{{data.blocked | number}}</div>
            </div>
        </div>
        <div class="agpr-undesirablesReport-mainRow">
            <div
                class="agpr-undesirablesReport-container"
                [ngClass]="{'agpr-undesirablesReport-container-selected' :
                    selectedType === statTypes.UNSUBSCRIBED && selectedIndividualRecipient === data
                }"
                (agprClickUnless)="selectStatType(statTypes.UNSUBSCRIBED)"
                tabindex="0"
                (keydown)="statCardKeydown($event, statTypes.UNSUBSCRIBED)"
            >
                <h5 class="agpr-undesirablesReport-typeLabel">
                    {{'Discover.distributionReport.recipient.statsType.unsubscribed' | localize}}
                    @if(data.negativeOutcome?.[statTypes.UNSUBSCRIBED] > 0){
                        <i
                            class="fa-solid fa-circle-exclamation agpr-undesirablesReport-typeIcon"
                            agprTooltip="Discover.distributionReport.recipient.statsType.icon.tooltip"
                        ></i>
                    }
                </h5>
                <div class="agpr-undesirablesReport-typeCount">{{data.unsubscribed | number}}</div>
            </div>
            <div
                class="agpr-undesirablesReport-container"
                [ngClass]="{'agpr-undesirablesReport-container-selected' :
                    selectedType === statTypes.HARD_BOUNCED && selectedIndividualRecipient === data
                }"
                (agprClickUnless)="selectStatType(statTypes.HARD_BOUNCED)"
                tabindex="0"
                (keydown)="statCardKeydown($event, statTypes.HARD_BOUNCED)"
            >
                <h5 class="agpr-undesirablesReport-typeLabel">
                    {{'Discover.distributionReport.recipient.statsType.hardBounced' | localize}}
                    @if(data.negativeOutcome?.[statTypes.HARD_BOUNCED] > 0){
                        <i
                            class="fa-solid fa-circle-exclamation agpr-undesirablesReport-typeIcon"
                            agprTooltip="Discover.distributionReport.recipient.statsType.icon.tooltip"
                        ></i>
                    }
                </h5>
                <div class="agpr-undesirablesReport-typeCount">{{data.hardBounced | number}}</div>
            </div>
            <div
                class="agpr-undesirablesReport-container"
                [ngClass]="{'agpr-undesirablesReport-container-selected' :
                    selectedType === statTypes.SPAM_REPORT && selectedIndividualRecipient === data
                }"
                (agprClickUnless)="selectStatType(statTypes.SPAM_REPORT)"
                tabindex="0"
                (keydown)="statCardKeydown($event, statTypes.SPAM_REPORT)"
            >
                <h5 class="agpr-undesirablesReport-typeLabel">
                    {{'Discover.distributionReport.recipient.statsType.spamReport' | localize}}
                    @if(data.negativeOutcome?.[statTypes.SPAM_REPORT] > 0){
                        <i
                            class="fa-solid fa-circle-exclamation agpr-undesirablesReport-typeIcon"
                            agprTooltip="Discover.distributionReport.recipient.statsType.icon.tooltip"
                        ></i>
                    }
                </h5>
                <div class="agpr-undesirablesReport-typeCount">{{data.spamReport | number}}</div>
            </div>
        </div>

        <!-- TODO : Restore this in v2 -->
        <!--agpr-message
            *ngIf="data.undesirableCount > 0"
            class="agpr-undesirablesReport-message"
            severity="warning"
        >
            <p>{{'Discover.distributionReport.recipient.undesirableMessage' | localize : {count:data.undesirableCount | number} }}</p>
            <agpr-button
                [style]="buttonTypes.outline"
                label="Discover.distributionReport.recipient.optimizeLists"
            >
            </agpr-button>
        </agpr-message-->
    </div>
</div>
